<template>
    <v-card>
        <slot name="header">
            <component :is="headerComponent"
                       v-bind="headerOptions"
                       :item="getItem"
                       :errors="getErrors"
                       :loading="loading"
                       @loading="$emit('loading', $event)"
                       @close="closeToolbox"/>
        </slot>

        <v-layout fill-height v-if="isLoading">
            <v-container fluid fill-height justify-center>
                <v-progress-circular :size="32" :width="3" color="#2ED1DF" indeterminate></v-progress-circular>
            </v-container>
        </v-layout>
        <div v-if="!isLoading" :style="getTabListStyle(getTabs)">
            <v-tabs v-model="activeTab" mandatory class="sr-tabs">
                <v-tab v-for="(tab, key) in getTabs" :key="key">
                    {{ tab.title || key }}
                </v-tab>
            </v-tabs>
        </div>

        <v-tabs-items v-model="activeTab" style="height: 100%; overflow-y: auto;" v-if="!isLoading">
            <v-tab-item v-for="(tab, key) in getTabs" :key="key">
                <component :is="tab.tab" v-model="getItem" :errors="getErrors" :loading="loading" @loading="$emit('loading', $event)"/>
            </v-tab-item>
        </v-tabs-items>
        <slot name="footer" v-if="!isLoading && !item.readonly">
            <component :is="footerComponent"
                       :item="getItem"
                       v-bind="footerOptions"
                       @close="closeToolbox"
                       @save="save"
                       :errors="getErrors"
                       :loading="loading"
                       @loading="$emit('loading', $event)"
            />
        </slot>
    </v-card>
</template>

<script>
  import Header from './default/Header'
  import Footer from './default/Footer'
  import _ from 'lodash'
  import { VBtn, VCard, VIcon, VTab, VTabItem, VTabs, VTabsItems, VToolbar } from 'vuetify/lib'
  import FadeLoader from '@/components/base/FadeLoader'

  export default {
    components: {
      FadeLoader,
      VCard,
      VToolbar,
      VBtn,
      VTabs,
      VTab,
      VIcon,
      VTabsItems,
      VTabItem
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      headerComponent: {
        type: Object,
        default: () => Header
      },
      headerOptions: {
        type: Object
      },
      footerComponent: {
        type: Object,
        default: () => Footer
      },
      footerOptions: {
        type: Object
      },
      useCopy: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        errors: null,
        copiedItem: null,
        activeTab: null
      }
    },
    created () {
      if (this.useCopy) {
        if (typeof this.item.clone === 'function') {
          this.copiedItem = this.item.clone()
        } else {
          this.copiedItem = _.cloneDeep(this.item)
        }
      }
    },
    methods: {
      getData () {
        return this.getItem
      },
      setData (newItem) {
        if (this.useCopy) {
          // should we clone it again?
          this.copiedItem = newItem
          return
        }

        this.item = newItem
      },
      setErrors (data) {
        this.errors = data
      },
      closeToolbox () {
        this.$emit('close')
      },
      save () {
        this.$emit('save')
      }
    },
    computed: {
      getTabs () {
        // ist mit absicht drin, damit sich der computed selbst aktualisiert
        // eslint-disable-next-line no-unused-vars
        if (typeof this.getItem.getToolboxTabs === 'function') {
          return this.getItem.getToolboxTabs()
        }

        return {}
      },
      getErrors () {
        return this.errors ? this.errors : this.getItem.toolboxErrors
      },
      isLoading () {
        if (typeof this.getItem.isLoaded === 'function') {
          this.$emit('loading', !this.getItem.isLoaded)
          return !this.getItem.isLoaded
        }

        if (typeof this.getItem.loaded === 'undefined') {
          this.$emit('loading', false)
          return false
        }
        this.$emit('loading', !this.getItem.loaded)

        return !this.getItem.loaded
      },
      getTabListStyle () {
        return (tabs) => {
          if (_.keys(tabs).length < 2) {
            return {
              display: 'none'
            }
          }

          return {}
        }
      },
      getItem: {
        get () {
          if (this.useCopy) {
            return this.copiedItem
          }

          return this.item
        },
        set (value) {
          if (this.useCopy) {
            this.copiedItem = value
            return
          }

          this.item = value
        }

      }
    }
  }
</script>

<style scoped>
    .footerBGColor {
        background-color: #f5f5f5;
    }

    .hideTabs {
        display: none;
    }
</style>
